import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/sharp-solid-svg-icons';
import { MouseEventHandler, useMemo } from 'react';

import Button, { ButtonVariant } from '@/components/button';
import Typography from '@/components/typography';
import {
  formatAcres,
  getAcresOfSelectionsPanelFeature,
} from '@/features/selectionsPanel/util/determineSelectionsPanelAcres';
import { AcresFeature } from '@/models/features';

import { CardDot } from './cardDot';

type Props = {
  feature: AcresFeature;
  idx?: number;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

export const CardTitle = ({ feature, onClose, idx = undefined }: Props) => {
  const acres = useMemo(
    () => getAcresOfSelectionsPanelFeature(feature),
    [feature]
  );
  const formattedAcres = useMemo(() => formatAcres(acres, false), [acres]);

  return (
    <div className="flex py-3">
      <CardDot feature={feature} idx={idx} />
      <Typography className="mr-1 leading-5" variant="h5">
        {formattedAcres}
      </Typography>
      <Typography className="leading-5">acres</Typography>
      <div className="flex-grow" />
      <div className="h-6 w-6">
        <Button
          className="p-1 leading-4 text-gray-70"
          variant={ButtonVariant.GHOST}
          onClick={onClose}
        >
          <FontAwesomeIcon className="!h-4 !w-4" icon={faClose} />
        </Button>
      </div>
    </div>
  );
};
